import { History, X } from 'lucide-react';

export default function HistoryPanel({ open, onClose, entries, onJump }) {
  if (!open) return null;
  return (
    <div className="fixed top-[112px] right-4 w-64 bg-white rounded-sm border border-[#E0DDD8] shadow-xl z-[60] flex flex-col max-h-[60vh]" data-testid="history-panel">
      <div className="flex items-center justify-between px-3 py-2 border-b border-[#E0DDD8] bg-[#FAFAFA]">
        <div className="flex items-center gap-1.5">
          <History className="w-3.5 h-3.5 text-[#C25934]" />
          <h3 className="text-xs font-semibold text-[#1C1C1C]">История</h3>
          <span className="mono-text text-[10px] text-[#5C5C5C]">({entries.length})</span>
        </div>
        <button onClick={onClose} className="p-0.5 rounded-sm hover:bg-black/5" data-testid="history-close">
          <X className="w-3.5 h-3.5 text-[#5C5C5C]" />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto custom-scrollbar py-1">
        {entries.length === 0 ? (
          <p className="text-[11px] text-[#5C5C5C] text-center py-6">Действий пока нет</p>
        ) : entries.map((e, i) => (
          <button
            key={e.id}
            onClick={() => onJump(i)}
            className={`w-full flex items-center gap-2 px-3 py-1.5 text-left text-[11px] hover:bg-[#F4F1ED] transition-colors ${
              e.current ? 'bg-[#C25934]/10 text-[#C25934] font-medium' : 'text-[#1C1C1C]'
            }`}
            data-testid={`history-entry-${i}`}
          >
            <span className="mono-text text-[9px] text-[#5C5C5C]/70 w-5 text-right">{i + 1}</span>
            <span className="flex-1 truncate">{e.label}</span>
            <span className="mono-text text-[9px] text-[#5C5C5C]/60">{e.time}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
